import React, { useCallback, useEffect, useState } from 'react';
import '../../Assets/Styles/offCanvas.css';
import { cartAddServiceTimeslot, checkValidCart, confirmBooking, getMyProfileDetails, serviceTimeSlotDetails, confirmEditBooking } from '../../Services/api';
import { useNavigate, useParams } from 'react-router-dom';
//firebase
import { getDatabase, ref, set, onValue } from "firebase/database";
import database from '../../Services/firebase-service/firebase';
import ReactLoading from 'react-loading';
import useRazorpay from "react-razorpay";
import { toast } from 'react-toastify';
import axiosInstance, { Razorpay_Key, environment, baseURL } from '../../Services/axios';
import bookingconfirm_img from "./../../Assets/Images/bookingconfirm.png";
import Lottie from "lottie-react";

import { useRef } from 'react';
import NodeaxiosInstance from '../../Services/nodeaxios';


const PayNowOffCanvas = ({ isOpen, paymentMethod, payAmount, toggleOffCanvas, getbookingId, cartDetail, service_instration, book_date_time, pageLoadedFunction }) => {

    const navigate = useNavigate();
    const bookingconfirm = useRef(null);

    const valueParam = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [bookingid, setBookingid] = useState('')

    const [paymentOrderId, setPaymentOrderId] = useState();
    const [userId, setUserId] = useState();
    const [Razorpay] = useRazorpay();
    const [offerServiceRedeemStatus, setofferServiceRedeemStatus] = useState()
    const [loyaltyPoints, setLoyaltyPoints] = useState()
    const [isModalOpen, setIsModalOpen] = useState(false)



    // function addServiceTimeSlot() {
    //     let localServiceDetail = localStorage.getItem('serviceDetail')
    //         ? JSON.parse(localStorage.getItem('serviceDetail'))
    //         : '';

    //     let param = {
    //         "vendor_id": valueParam.vendor_id,
    //         "cart_app_id": (localServiceDetail && localServiceDetail?.cart_app_id) ? localServiceDetail?.cart_app_id : '',
    //         "booking_type": "1",
    //         "date": date,
    //         "time_section": section,
    //         "time_slot": slot,
    //         "service_type": (localServiceDetail && localServiceDetail?.serviceType) ? localServiceDetail?.serviceType : '',
    //     };

    //     cartAddServiceTimeslot(param).then((res) => {

    //         if (res.data?.status == '1') {
    //             navigate(`/review-and-pay/${valueParam.vendor_id}`)
    //         }
    //     })
    // }

    useEffect(() => {
        // if (!currentUser) return; // Check if user is not logged in
        const database = getDatabase();
        const orderRef = ref(database, `/payments/service_booking/${userId}`);
        // const orderRef = ref(database, `/payments/product_order/23U00002`);
        const unsubscribe = onValue(orderRef, snapshot => {
            const data = snapshot.val();
            if (data?.status === 2 && data?.order_id === paymentOrderId) {
                toggleOffCanvas()
                if (cartDetail.edit_service_status == 1) {
                    getbookingId(cartDetail.cart_app_id)
                } else {
                    getbookingId(data.booking_id)

                }

                // openPaymentSuccessModal()
            }
            // if (data.status === 3 && data.order_id === paymentOrderId) {
            // }
        });
        return () => unsubscribe(); // Detach listener on cleanup

    }, [paymentOrderId]);

    useEffect(() => {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
        let offer_redeem_status = localServiceDetail.offer_status ? localServiceDetail.offer_status : '';
        let loyalty_redeem_points = localServiceDetail.loyalty_points ? localServiceDetail.loyalty_points : '';
        setLoyaltyPoints(loyalty_redeem_points)
        setofferServiceRedeemStatus(offer_redeem_status)
    }, [])

    function payNow() {

        setIsLoading(true);

        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';

        let param = {
            "vendor_id": valueParam.vendor_id,
            "cart_app_id": localServiceDetail.cart_app_id,
            "by_pingle_points": 0,
            "payment_method": paymentMethod,
            "delivery_tip": service_instration().delivery_tip,
            "delivery_instructions": service_instration().delivery_instructions,
            "additional_notes": service_instration().additional_notes,
            "voice_note": service_instration().voice_note,

        };


        checkValidCart(param).then((res) => {
            let userDetail = {
                name: "",
                phone: "",
                email: "",
            };

            if (res.data.status == '1') {
                setIsValid(true)
                if (cartDetail?.edit_service_status == 1) {
                    if (cartDetail?.edit_service_datails.pay_status == 1) {
                        setPaymentOrderId(res.data?.payment?.id);
                        setUserId(res.data?.user_id);


                        handlePayment(res?.data?.user_details, res.data?.payment);
                        setIsLoading(false);
                    } else {
                        confirm_edit_booking()
                        setIsLoading(false);
                    }
                } else if (paymentMethod == '3') {
                    bookingConfirm();
                } else {
                    setPaymentOrderId(res.data?.payment?.id);
                    setUserId(res.data?.user_id);
                    userDetail['user_id'] = res.data?.user_id;
                    handlePayment(userDetail, res.data?.payment);
                    setIsLoading(false);
                }

            }
            // localStorage.removeItem('localStorageserviceTime');
        }).catch((error) => {
            if (error.response.status == 400) {

                toast(error.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                setIsLoading(false)
                setIsValid(false)
            }
            if (error.response.status == 500) {
                toast('something went wrong please try again', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                setIsLoading(false)
            }
        })

    };

    function bookingConfirm() {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';

        let param = {
            "cart_app_id": localServiceDetail.cart_app_id,
        };

        confirmBooking(param).then((res) => {

            if (res.data.status == '1') {
                openBookingconfirm()

            }
        });
    }

    // const handlePayment = useCallback((userData, orderData) => {
    //     const createOrderAndInitializePayment = async () => {
    //         const options = {
    //             key: Razorpay_Key,
    //             amount: orderData.amount,
    //             currency: orderData.currency,
    //             name: "PINGLE",
    //             description: "Payment",
    //             image: 'https://pingle.in/user/assets/images/LogoUser.png',
    //             order_id: orderData.id,
    //             handler: (res) => {
    //             },
    //             prefill: {
    //                 name: userData.name,
    //                 email: userData.email,
    //                 contact: userData.phone,
    //             },
    //             theme: {
    //                 color: "#4E26A3",
    //             },
    //         };

    //         const rzpay = new Razorpay(options);
    //         rzpay.open();
    //     };

    //     createOrderAndInitializePayment();
    // }, [Razorpay]);


    // const handlePayment = useCallback(
    //     (userData, orderData, vendorId) => { 

    //         const createOrderAndInitializePayment = async () => {
    //             // Detect environment
    //             // const isLocal = window.location.origin.startsWith("http://");
    //             const origin = `https://web.pingle.in/web-test/payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData.user_id}`;
    //             // const origin = `http://localhost:3000/web-test/payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData.user_id}`;
    //             // const origin = `https://web.pingle.in/payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData.user_id}`;

    //             // Base options
    //             const currentPageUrl = window.location.href; 

    //             const options = {
    //                 key: Razorpay_Key,
    //                 amount: orderData?.amount,
    //                 currency: orderData.currency,
    //                 name: "PINGLE",
    //                 description: "Payment",
    //                 image: "https://pingle.in/user/assets/images/LogoUser.png",
    //                 order_id: orderData.id,
    //                 // handler: (res) => { 
    //                 // },
    //                 handler: (res) => {
    //                     // You can manually navigate or call API here:
    //                     // window.location.href = `/web-test/payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData.user_id}`;
    //                 },
    //                 prefill: {
    //                     name: userData.name,
    //                     email: userData.email,
    //                     contact: userData.phone,
    //                 },
    //                 theme: { color: "#4E26A3" },
    //                 modal: {
    //                     ondismiss: function () { 

    //                     },
    //                 },
    //                 redirect: true,
    //                 callback_url: origin,
    //             };

    //             const rzpay = new Razorpay(options);
    //             rzpay.on('payment.failed', function (response) { 

    //             });
    //         }; 
    //         createOrderAndInitializePayment();
    //     },
    //     [Razorpay]
    // );

    // const contactNumber = String(productDetail?.user_details?.user_mbl || userData?.phone || "").replace(/\D/g, "").slice(-10);

    const handlePayment = useCallback(
        (userData, orderData, vendorId) => {
            const createOrderAndInitializePayment = async () => {
                let origin = "";
                if (environment == "TEST" || environment == "PRODUCTION") {
                    origin = `${baseURL}payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData?.user_id}`;
                } else {
                    origin = `${window.location.origin}/payment-completed?order_id=${orderData.id}&type=serviceBooking&user_id=${userData?.user_id}`;
                }

                pageLoadedFunction(false);
                const options = {
                    key: Razorpay_Key,
                    amount: orderData?.amount,
                    currency: orderData.currency,
                    name: "PINGLE",
                    description: "Payment",
                    image: "https://pingle.in/user/assets/images/LogoUser.png",
                    order_id: orderData.id,
                    handler: (res) => {
                        window.location.href = origin;
                    },
                    prefill: {
                        name: userData.user_name,
                        email: userData.user_email,
                        contact: userData.user_mobile,
                    },
                    theme: { color: "#4E26A3" },
                    modal: {
                        ondismiss: function () {
                            pageLoadedFunction(true);
                        },
                    },
                };

                const rzpay = new Razorpay(options);
                rzpay.open();
                rzpay.on("payment.failed", function (response) {
                });
            };

            createOrderAndInitializePayment();
        },
        [Razorpay]
    );

    const redeem_loyalty = () => {
        try {
            let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
            let vendor_id = localServiceDetail.vendorId ? localServiceDetail.vendorId : '';
            let cart_id = localServiceDetail.cart_app_id ? localServiceDetail.cart_app_id : '';
            let loyalty_id = localServiceDetail.loyalty_offerID ? localServiceDetail.loyalty_offerID : '';
            let service_type = localServiceDetail.serviceType ? localServiceDetail.serviceType : '';

            let reqData = {
                "vendor_id": vendor_id,
                "offer_id": loyalty_id,
                "cart_app_id": cart_id,
                "note_desc": ""
            }
            NodeaxiosInstance.get('/profile/redeem-vendor-loyalty-offer', reqData)
                .then((res) => {
                    if (res?.status == 200) {
                        setBookingid(res.data.booking_id)
                        openBookingconfirm()
                    }
                })
        }
        catch (err) {
            console.error("Error fetching loyalty details:", err);

            const status = err?.response?.status;

            if (status == 400 || status == 500) {
                // setPageLoaded(false);
            }

        } finally {
            console.log("Loyalty details API call completed");
        }
    }

    const confirm_edit_booking = () => {
        try {
            setIsLoading(true);

            let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';

            let param = {
                "vendor_id": valueParam.vendor_id,
                "cart_app_id": localServiceDetail.cart_app_id
            };
            confirmEditBooking(param).then((res) => {


                if (res.data.status == '1') {
                    setIsValid(true)
                    // navigate(`/details/${ localServiceDetail.cart_app_id}`, { state: { fromPage: "ReviewPay" } });
                    // toggleOffCanvas()
                }

            }).catch((error) => {
                if (error.response.status == 400) {
                    toast(error.response.data.message, {
                        position: "top-center", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                        pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
                    });
                    setIsLoading(false)
                    setIsValid(false)
                }
                if (error.response.status == 500) {
                    toast('something went wrong please try again', {
                        position: "top-center", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                        pauseOnHover: true, draggable: true, progress: undefined, theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                    setIsLoading(false)
                }
            })
        }
        catch {

        }
    }

    const openBookingconfirm = () => {
        bookingconfirm.current.classList.add("show");
        bookingconfirm.current.style.display = "block";
        setIsModalOpen(true)
        setIsLoading(false);
    };

    const closeBookingconfirm = () => {
        bookingconfirm.current.classList.remove("show");
        setIsModalOpen(false)
        localStorage.removeItem("selectedServiceOption");
        localStorage.removeItem('serviceDetail');
        localStorage.removeItem('serviceAdded');
        localStorage.removeItem('productAdded');
        localStorage.removeItem('EditOrder_Detail');
        localStorage.removeItem('localStorageserviceTime');
        localStorage.removeItem("shipping_type");
        localStorage.removeItem("productDeliveryTime");
        localStorage.removeItem("cartid")
        localStorage.removeItem("appliedCard")
        sessionStorage.removeItem('membership');

        if (bookingid) {
            navigate(`/details/${bookingid}`, { state: { fromPage: "ReviewPay" } });
        } else if (!bookingid) {
            navigate('/', { replace: true });

        }

    };

    return (

        <>
            <div className={`px-2 py-4`} style={{ width: '100%', position: 'sticky', bottom: 0, backgroundColor: '#fff', borderTopLeftRadius: 20, borderTopRightRadius: 20, marginTop: 10 }}>
                <div className="offcanvas-body small">

                    {/* <textarea style={{ width: '100%', borderRadius: 6, height: 100 }} placeholder='Add notes and instructions if any' className='p-2'></textarea> */}

                    {
                        offerServiceRedeemStatus == '1' ?
                            <button type='button' className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn mt-3' onClick={() => redeem_loyalty()} >
                                Redeem Now
                            </button> :
                            paymentMethod == '2' ?
                                <button type='button' className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn mt-3'
                                    onClick={() => payNow()} >
                                    Pay ₹{cartDetail.payment_options.advance_amount}
                                </button> :
                                paymentMethod == '3' ?
                                    <button type='button' className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn mt-3'
                                        onClick={() => !isLoading && payNow()} >
                                        {isLoading ? (
                                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                            </div>
                                        ) : ('Booking Confirm')}

                                    </button>
                                    :
                                    <>
                                        {
                                            cartDetail?.edit_service_status == 1 ?

                                                cartDetail.edit_service_datails.pay_status == 1 ?
                                                    <>
                                                        <button type='button'
                                                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'
                                                            onClick={() => payNow()}
                                                            disabled={isLoading && isValid}
                                                            style={{ position: 'relative' }} // Set position relative for button
                                                        >
                                                            {isLoading && (
                                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                                    <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                                                </div>
                                                            )}
                                                            {!isLoading && `Pay ₹${cartDetail.edit_service_datails.balance_amount}`}
                                                        </button>
                                                    </> :
                                                    <>

                                                        <button type='button'
                                                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'
                                                            onClick={() => payNow()} disabled={isLoading && isValid} style={{ position: 'relative' }}
                                                        >
                                                            {isLoading && (
                                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                                    <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                                                </div>
                                                            )}
                                                            {!isLoading && `Booking Confirm ₹${cartDetail.edit_service_datails.balance_amount}`}
                                                        </button>
                                                    </>
                                                :
                                                cartDetail?.applied_card_detail?.offer_type == 4 ?
                                                    <>
                                                        <button type='button'
                                                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn'
                                                            onClick={() => payNow()}
                                                            disabled={isLoading && isValid}
                                                            style={{ position: 'relative' }} // Set position relative for button
                                                        >
                                                            {isLoading && (
                                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                                    <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                                                </div>
                                                            )}
                                                            {!isLoading && `Pay ₹${(
                                                                Number(cartDetail.applied_card_detail.offer_price)
                                                                + Number(cartDetail.payment_details.user_platform_charges)
                                                                + (cartDetail.GST_status == 1
                                                                    ? Number(cartDetail.payment_details.SGST_amount || 0) + Number(cartDetail.payment_details.CGST_amount || 0)
                                                                    : 0)
                                                                + Number(cartDetail.payment_details.round_of || 0)
                                                            ).toFixed(2)}`}
                                                        </button>
                                                    </> :
                                                    <>
                                                        <button type='button'
                                                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white payNowBtn' onClick={() => payNow()}
                                                            disabled={isLoading && isValid} style={{ position: 'relative' }}
                                                        >
                                                            {isLoading && (
                                                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                                                    <ReactLoading type={'spinningBubbles'} color={'#fff'} height={'20px'} width={'20px'} />
                                                                </div>
                                                            )}
                                                            {!isLoading && `Pay  ₹${payAmount}`}
                                                        </button>
                                                    </>
                                        }
                                    </>
                    }
                </div>
            </div>


            <div className={`modal fade`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={bookingconfirm} data-bs-backdrop="false" style={{ backgroundColor: "#fff" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content modal-success" style={{ width: 300 }}>
                        <div className="modal-body justify-content-center mt-3">
                            <div className='d-flex justify-content-center'>
                                <img src={bookingconfirm_img} height="100px" width="130px" />
                            </div>
                            <div className="text-center ff-poppins-semiBold fs-16  primary-text mt-4">
                                Booking Confirmed
                            </div>
                            <div className="text-center ff-poppins-semiBold mt-4 fs-14 ">
                                <p className='p-0 m-0 secondary-text'>  Your service booked on date is</p>
                                <p className='p-0 m-0 primary-text'>{book_date_time}</p> .

                                <button type="button" className="btn rounded-pill ff-poppins-semiBold col-6 primary-bg text-white rounded my-3"
                                    onClick={() => closeBookingconfirm()} style={{ backgroundColor: '#4e26a3', color: 'white' }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && <div className="modal-backdrop fade show"></div>}

        </>

    )

}
export default PayNowOffCanvas;